import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

export default function Syndicates() {
  const [syns, setSyns] = useState([]);
  useEffect(() => { api.get("/syndicates").then((r) => setSyns(r.data)); }, []);
  return (
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-16">
      <div className="small-label text-rtrl-red">Constructors</div>
      <h1 className="font-display uppercase text-5xl md:text-6xl text-white mt-2">Syndicates</h1>
      <p className="text-white/60 mt-2">Up to 20 custom syndicates compete for the RTRL Cup.</p>

      <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {syns.map((s) => (
          <Link key={s.id} to={`/syndicates/${s.id}`} data-testid={`syn-card-${s.tag}`}
            className="rtrl-card carbon-bg p-6 relative overflow-hidden transition-transform duration-200 hover:-translate-y-1 group">
            <div className="absolute left-0 top-0 bottom-0 w-1" style={{ background: s.color }} />
            <div className="flex items-center justify-between">
              <div>
                <div className="small-label" style={{ color: s.color }}>{s.tag}</div>
                <h3 className="font-display uppercase text-3xl text-white mt-1">{s.name}</h3>
              </div>
              <div className="w-10 h-10 border-2" style={{ borderColor: s.color }} />
            </div>
            <p className="text-white/50 text-sm mt-4">{s.bio}</p>
            <div className="small-label mt-4 text-rtrl-silver group-hover:text-rtrl-red transition-colors">View roster →</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
